import type { BackendTypes } from '@tf/api';
import { processReviewGraph } from '@tf/shared';
import { useMemo } from 'react';

import { useApplication } from '@/components/application';

export const useExistingEntities = (excludeEntityId: BackendTypes.GraphId, entityKinds: BackendTypes.EntityKind[]) => {
	const application = useApplication();

	return useMemo(() => {
		const uniqueEntities: Record<BackendTypes.GraphId, BackendTypes.Entity> = {};

		application.reviews.forEach((review) => {
			processReviewGraph({
				accountId: application.account.graphNodeId,
				review,
				processorFn: ({ childEntity }) => {
					if (childEntity.graphNodeId !== excludeEntityId && entityKinds.includes(childEntity.entityKind)) {
						uniqueEntities[childEntity.graphNodeId] = childEntity;
					}
				},
			});
		});

		return Object.values(uniqueEntities);
	}, [application.account.graphNodeId, application.reviews, entityKinds, excludeEntityId]);
};
